import { useState, ReactNode } from "react"
import { Head } from "@inertiajs/react"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card"
import { Button } from "../../components/ui/button"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "../../components/ui/dialog"
import { Plus } from "lucide-react"
import AddBlogPost from "./AddBlogPost"
import BlogPostsList from "./BlogPostsList"
import AdminLayout from "../../layouts/AdminLayout"

const BlogPosts = () => {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Head title="Blog Posts" />

      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
            <DialogTrigger asChild>
              <Button>
                <Plus className="h-4 w-4 mr-2" />
                Add New Post
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle>Add New Blog Post</DialogTitle>
                <DialogDescription>
                  Fill out the form below to create a new blog post. All fields marked with * are required.
                </DialogDescription>
              </DialogHeader>
              <AddBlogPost onSuccess={() => setDialogOpen(false)} />
            </DialogContent>
          </Dialog>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>All Blog Posts</CardTitle>
            <CardDescription>
              View and manage all your blog posts with pagination
            </CardDescription>
          </CardHeader>
          <CardContent>
            <BlogPostsList />
          </CardContent>
        </Card>
      </div>

    </>
  )
}

BlogPosts.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>

export default BlogPosts
